import { apiClient } from './client';
import type { ClientsPageMeta } from './clients';

/**
 * Шаблон соглашения об обработке ПД — GET/POST/PUT /operator-templates
 * (см. докблок OperatorTemplateController в Laravel, 1:1 старые Orchid-экраны
 * OperatorListScreen/OperatorEditScreen).
 */
export interface OperatorTemplateRow {
  id: number;
  name: string;
  description: string | null;
  text: string;
  default: boolean;
}

export interface FetchOperatorTemplatesParams {
  search?: string;
  page?: number;
}

export interface OperatorTemplatesPage {
  items: OperatorTemplateRow[];
  meta: ClientsPageMeta;
}

export async function fetchOperatorTemplates(
  params: FetchOperatorTemplatesParams = {},
): Promise<OperatorTemplatesPage> {
  const { data } = await apiClient.get<OperatorTemplatesPage>('/operator-templates', { params });
  return data;
}

export interface SaveOperatorTemplatePayload {
  name: string;
  description?: string | null;
  text: string;
  default: boolean;
}

export async function createOperatorTemplate(
  payload: SaveOperatorTemplatePayload,
): Promise<OperatorTemplateRow> {
  const { data } = await apiClient.post<OperatorTemplateRow>('/operator-templates', payload);
  return data;
}

export async function updateOperatorTemplate(
  id: number,
  payload: SaveOperatorTemplatePayload,
): Promise<OperatorTemplateRow> {
  const { data } = await apiClient.put<OperatorTemplateRow>(`/operator-templates/${id}`, payload);
  return data;
}

export async function deleteOperatorTemplate(id: number): Promise<void> {
  await apiClient.delete(`/operator-templates/${id}`);
}

export async function setDefaultOperatorTemplate(id: number): Promise<OperatorTemplateRow> {
  const { data } = await apiClient.put<OperatorTemplateRow>(`/operator-templates/${id}/default`, {});
  return data;
}
